export enum LocalStorageKey {
  USER = 'user',
  ACCESS_TOKEN = 'access_token',
  BOOTSTRAP_TOKENS = 'bootstrap_tokens',
  SELECTABLE_USERS = 'selectable_users',
  DESKTOP_GRID = 'desktop_grid',
  DESKTOP_GRID_MOBILE = 'desktop_grid_mobile',
  DESKTOP_SHORTCUT_GROUPS = 'desktop_shortcut_groups',
  COMPLETED_TOURS = 'completed_tours',
  THEME = 'theme',
  REMEMBER_ME = 'remember_me',
  DISABLED_RICH_APP_ICONS = 'disabled_rich_app_icons',
  DEV_DRAWER_VISIBLE = 'dev_drawer_visible',
  AVAILABLE_APPS_CACHE = 'available_apps_cache',
  FEATURE_FLAGS_CACHE = 'feature_flags_cache',
  PREFERENCES = 'preferences',
  NEWS_TICKER_DISMISSED = 'news_ticker_dismissed',
  DESKTOP_APP_FOLDER_ID = 'desktop_app_folder_id',
  AGENT_CHAT_WIDGET_VISIBLE = 'clusterix-agent-chat-launcher/widget-visible',
  AGENT_CHAT_WIDGET_HIDE_EXPIRY = 'clusterix-agent-chat-launcher/widget-hide-expiry'
}

export const AGENT_CHAT_WIDGET_HIDE_DURATIONS_MS = {
  for_1_hour: 3_600_000,
  for_1_day: 86_400_000,
  for_1_week: 604_800_000
} as const
